module.exports = __webpack_public_path__ + "img/headerImage.e4486d7b.jpg";